import {useCallback} from 'react';
import {useDispatch} from 'react-redux';

import {useCachedTable} from 'src/hooks/common-data-service/cached-table';
import {getProfileAdmins} from 'src/openapi/admin/apis/GetProfileAdminsApi';
import {useAppDispatch} from 'src/store/hooks';

import {
    assignedUsersActions,
    assignedUsersDataSelector,
    assignedUsersResultSelector,
} from '../slices/assigned-users-slice';
import {assignedUsersStateSelector} from '../slices/assigned-users-state-slice';

import type {AssignedUsersCacheKeys} from '../typedef';
import type {AdminUserPage} from 'src/openapi/admin/models/AdminUserPage';


export const useGetAssignedUsers = () => {
    const apiDispatch = useAppDispatch();
    const dispatch = useDispatch();

    const getAction = useCallback((cacheKeys: AssignedUsersCacheKeys) => apiDispatch(getProfileAdmins({
        profileId: cacheKeys.searchCriteria.profileId || -1,
        pageSize: cacheKeys.pagination.pageSize,
        pageNumber: cacheKeys.pagination.currentPage,
        sortField: cacheKeys.sortCriteria.field,
        sortDirection: cacheKeys.sortCriteria.direction,
        searchByEmail: cacheKeys.filters.email as string || undefined,
    })), [apiDispatch]);

    const setLoadedData = useCallback((
        response: AdminUserPage,
        cacheKeys: AssignedUsersCacheKeys,
    ) => dispatch(assignedUsersActions.onSuccess(({
        cacheKeys,
        totalCount: response.totalCount,
        data: response.users,
    }))), [dispatch]);

    return useCachedTable({
        dataSelector: assignedUsersDataSelector,
        stateSelector: assignedUsersStateSelector,
        resultSelector: assignedUsersResultSelector,
        actions: assignedUsersActions,
        getAction,
        onSuccessLoad: setLoadedData,
    });
};
